// Copyright 2021 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { SettingsModal } from "modules/modals/SettingsModal";
import { FarFieldModule } from "modules/workflows/Streamer/FarField/FarFieldModule";

@autoinject
export class StreamerFarFieldSettingsModal extends SettingsModal<FarFieldModule> {}
